import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_NOTE_DOCS_REQUEST: '',
  GET_NOTE_DOCS_SUCCESS: '',
  GET_NOTE_DOCS_FAILURE: '',

  DELETE_NOTE_DOC_REQUEST: '',
  DELETE_NOTE_DOC_SUCCESS: '',
  DELETE_NOTE_DOC_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityNoteDocs');

export default types;
